module.exports = __webpack_public_path__ + "static/media/br14.85aa2395.jpg";